import { Action } from '@ngrx/store';
import { TaskInterface } from 'app/task/models/task.model';

import { TaskActionType } from './task-action-type.enum';


export class CreateTask implements Action {
  public readonly type: TaskActionType = TaskActionType.CreateTask;

  constructor(public readonly payload: TaskInterface) { }
}

export class CreateSurveyTask implements Action {
  public readonly type: TaskActionType = TaskActionType.CreateSurveyTask;

  constructor(public readonly payload: TaskInterface) { }
}

export class CreateTaskCompleted implements Action {
  public readonly type: TaskActionType = TaskActionType.CreateTaskCompleted;

  constructor(public readonly payload: TaskInterface) { }
}

export class CreateTaskFailed implements Action {
  public readonly type: TaskActionType = TaskActionType.CreateTaskFailed;

  constructor(public readonly payload: string) { }
}
